import React from "react";
import { Modal } from "react-bootstrap";
import MlsMatchCard from "@/components/MlsListings/MlsMatchCard";

// Shown when the selected address matches the agent's own MLS listing.
const MlsOwnedListingModal = ({ show, onHide, listing, onSelect }) => {
  return (
    <Modal show={show} onHide={onHide} size="lg" centered>
      <Modal.Header closeButton>
        <Modal.Title
          className="flex-grow-1 text-center"
          style={{ fontSize: "1.5rem" }}
        >
          You already have an MLS listing here
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p className="mb-3 fw-bold" style={{ fontSize: "1.15rem" }}>
          This address matches one of your MLS listings. Select it to autofill
          the property details from that listing.
        </p>
        {listing && (
          <MlsMatchCard
            list={listing}
            onClick={() => onSelect && onSelect(listing)}
          />
        )}
      </Modal.Body>
    </Modal>
  );
};

export default MlsOwnedListingModal;
